import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";
import capitalize from "lodash-es/capitalize";
import { useIntl } from "react-intl";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import anyColorToHex from "@app/util/colors/anyColorToHex";
import { getColorDisplayName } from "@app/util/ui";

import styles from "./ColorCellRenderer.module.scss";

const ColorCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const intl = useIntl();

  if (!value) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  return (
    <div className={styles.container}>
      <span
        className={styles.colorTag}
        style={{ backgroundColor: anyColorToHex(value as AnyColor) }}
      >
        &nbsp;
      </span>
      <span className={styles.valueText}>{capitalize(getColorDisplayName(intl, value))}</span>
    </div>
  );
};

export default ColorCellRenderer;
